export default {
    ADD_PORTFOLIO_ASSET_CLASS_NAME_BOND: "Bonds",
    ADD_PORTFOLIO_ASSET_CLASS_NAME_CASH: "Cash",
    ADD_PORTFOLIO_ASSET_CLASS_NAME_NON_US_STOCK: "Non-US Stocks",
    ADD_PORTFOLIO_ASSET_CLASS_NAME_OTHER: "Other/Not Clsfd",
    ADD_PORTFOLIO_ASSET_CLASS_NAME_US_STOCK: "US Stocks",
    ADD_PORTFOLIO_HEADER: "Add Portfolio",
    ADD_PORTFOLIO_SEARCH_PLACEHOLDER: "Search by Portfolio Name",
    ADD_PORTFOLIO_TITLE: "Select a portfolio to analyze in this hypothetical.",
    AND: "and",
    ARCHIVE_HYPOS_ACTIONS_SEARCH_PLACEHOLDER: "Search by Hypothetical Name",
    ARCHIVE_HYPOS_COLUMN_HYPO_NAME: "Hypothetical Name",
    ARCHIVE_HYPOS_COLUMN_MODIFIED_TIME: "Date Modified",
    ARCHIVE_HYPOS_EMPTY_HYPO_TITLE: "Not Results Found",
    ARCHIVE_HYPOS_EMPTY_HYPO_DESCRIPTION: "Try adjusting your search",
    ARCHIVE_REPORTS_ACTIONS_DOWNLOAD: "Download PDF",
    ARCHIVE_REPORTS_ACTIONS_SEARCH_PLACEHOLDER: "Search by Report Name",
    ARCHIVE_REPORTS_COLUMN_HYPO_NAME: "Hypothetical Name",
    ARCHIVE_REPORTS_COLUMN_MODIFIED_TIME: "Date Modified",
    ARCHIVE_REPORTS_COLUMN_REPORT_NAME: "Report Name",
    ARCHIVE_REPORTS_TAG_FIRM_SAVED: "Firm Saved",
    ARCHIVE_TABS_HYPOS: "Hypothetical",
    ARCHIVE_TABS_REPORTS: "Report",
    ARCHIVE_FILTER_ALL: "All",
    ARCHIVE_FILTER_FIRM_SAVED_ONLY: "Firm Saved Only",
    ASSET_CLASS: "Asset Class %",
    ASSET_CLASS_AC_ALLBOND: "Bonds",
    ASSET_CLASS_AC_BOND_OTHER: "Other Bonds",
    ASSET_CLASS_AC_EMERGEQ_NOOTHER: "Non-US Emerging Stocks",
    ASSET_CLASS_AC_NUSBOND: "Non-US Bonds",
    ASSET_CLASS_AC_NUSDEVEQ: "Non-US Developed Stocks",
    ASSET_CLASS_AC_NUSEQ: "Non-US Stocks",
    ASSET_CLASS_AC_NUSEQ_OTHER: "Other Non-US Stocks",
    ASSET_CLASS_AC_OTHER_USDTL_15: "Other",
    ASSET_CLASS_AC_USBROAD_OTHER: "Other/Not Clsfd",
    ASSET_CLASS_AC_USCASH: "Cash",
    ASSET_CLASS_AC_USEQ: "US Stocks",
    ASSET_CLASS_AC_USEQ_OTHER: "Other US Stocks",
    ASSET_CLASS_AC_USHYBOND: "US High-Yield Bonds",
    ASSET_CLASS_AC_USIGBOND: "US Investment Grade Bonds",
    ASSET_CLASS_AC_USLCEQ: "US Large-Core Stocks",
    ASSET_CLASS_AC_USLGEQ: "US Large-Cap Growth Stocks",
    ASSET_CLASS_AC_USLVEQ: "US Large-Cap Value Stocks",
    ASSET_CLASS_AC_USMCEQ: "US Mid-Cap Stocks",
    ASSET_CLASS_AC_USSCEQ: "US Small-Cap Stocks",
    ALERT_BENCHMARK_NOPRICE_TITLE: "Select a different benchmark.",
    ALERT_BENCHMARK_NOPRICE_MSG: "The selected benchmark contains holdings that don't have price data on the portfolio end date.",
    ALERT_EDIT_ASSUMPTIONS_DIFFTIMEPERIOD_TITLE: "Portfolio time period does not match.",
    ALERT_EDIT_ASSUMPTIONS_DIFFTIMEPERIOD_MSG:
        "The start date and end date for Portfolio 1 and Portfolio 2 must match. Please select a same time period for both Portfolio 1 and Portfolio 2.",
    ALERT_EDIT_ASSUMPTIONS_DIFFCOMMONTIMEPERIOD_TITLE: "No Common End Date",
    ALERT_EDIT_ASSUMPTIONS_DIFFCOMMONTIMEPERIOD_MSG: "The investments do not have a common end date. Go back to change the investments.",
    ALERT_EDIT_ASSUMPTIONS_DIFFCOMMONTIMEPERIOD_ACTION: "Go Back to Portfolio",
    BENCHMARK_AUTO_BY_ASSET_ALLOCATION: "Auto Benchmark By Asset Allocation",
    BENCHMARK_AUTO_BY_MSTAR_CATEGORY: "Auto Benchmark By Morningstar Category",
    BENCHMARK_CUSTOM: "Custom Benchmark",
    BENCHMARK_DISCLOSURE: "Disclosure",
    BENCHMARK_HOLDINGS: "Benchmark Holdings",
    BENCHMARK_NO_SELECTION_ADDED: "No selection added.",
    BENCHMARK_REVIEW_INDEXES: "Review the indexes selected.",
    BENCHMARK_SECURITY_IDENTIFIER: "Identifier",
    BENCHMARK_SECURITY_NAME: "Name",
    BENCHMARK_SELECT_TITLE: "Select how you create a benchmark.",
    BENCHMARK_STANDARD: "Index",
    BENCHMARK_WEIGHT_WITH_PERCENT: "Weights %",
    CHART_ASSET_ALLOCATION: "Asset Allocation",
    HOLDINGS_SECTION: "Holdings",
    HOLDINGS_SECTION_INVESTMENT_FLOW: "Investments",
    AS_OF: "As of",
    CHART_PERFORMANCE_ANNUAL_RETURN_TITLE: "Annual Return %",
    CHART_PERFORMANCE_MARKET_VALUE_TITLE: "Market Value",
    CHART_PERFORMANCE_TRAILING_RETURN_TITLE: "Trailing Return %",
    CHOOSE_SOURCE_TEXT: "Choose the source of investments for the Portfolio",
    CHOOSE_SOURCE_OPTION_CUSTOM: "Custom Portfolio",
    CHOOSE_SOURCE_DUPLICATE: "Duplicate Portfolio 1",
    CHOOSE_SOURCE_OPTION_SAVED_HYPO: "Saved Hypothetical Portfolios",
    CHOOSE_SOURCE_OPTION_MODEL: "Model Portfolio",
    CHOOSE_SOURCE_OPTION_CLIENT: "Client Accounts",
    CHOOSE_SOURCE_OPTION_LISTS: "Lists",
    CHOOSE_SOURCE_OPTION_SAVED_SEARCHES: "Saved Searches",
    COMMON_PREFERENCES: "Preferences",
    COMMON_SIGN_OUT: "Sign Out",
    COMMON_YES: "Yes",
    COMMON_STAY_IN: "No, stay in",
    COMMON_SIGN_OUT_TITLE: "Are you sure you want to sign out of Hypothetical Illustrator?",
    COMMON_ADD: "Add",
    COMMON_BENCHMARK: "Benchmark",
    COMMON_CANCEL: "Cancel",
    COMMON_CHECK_ALL: "Check All",
    COMMON_CLOSE: "Close",
    COMMON_DELETE: "Delete",
    COMMON_DELETE_HYPO_DIALOG_TITLE: "Are you sure you want to delete this hypothetical file?",
    COMMON_SAVE_HYPO_DIALOG_TITLE: "Are you sure you want to save and close the file?",
    COMMON_SAVE_DUPLICATE_DIALOG_TITLE: "Are you sure you want to duplicate the file?",
    COMMON_SAVE_HYPO_DIALOG_ERROR: "Can't save and close file with existing name. Change the name above and try again",
    COMMON_RENAME_HYPO_DIALOG_ERROR: "Can't rename file with existing name. Change the name above and try again",
    COMMON_LENGTH_HYPO_DIALOG_ERROR: "Hypo name cannot be more than 100 characters.",
    COMMON_DONE: "Done",
    COMMON_EDIT: "Edit",
    COMMON_FREQUENCY: "Frequency",
    COMMON_FREQUENCY_ANNUALLY: "Once a Year",
    COMMON_FREQUENCY_MONTHLY: "Once a Month",
    COMMON_FREQUENCY_QUARTERLY: "Every 3 Months",
    COMMON_FREQUENCY_BIENNIALLY: "Every 2 Years",
    COMMON_FREQUENCY_SEMI_ANNUALLY: "Twice a Year",
    COMMON_INCLUDE: "Include",
    COMMON_NEXT: "Next",
    COMMON_PREVIOUS: "Previous",
    COMMON_NOT_SAVE: "Don’t Save",
    COMMON_OK: "OK",
    COMMON_PORTFOLIO: "Portfolio",
    COMMON_RENAME_PORTFOLIO_DIALOG_TITLE: "What would you like to name this portfolio?",
    COMMON_REMOVE: "Remove",
    COMMON_RENAME: "Rename",
    COMMON_RENAME_HYPO_DIALOG_TITLE: "What would you like to name this hypothetical?",
    COMMON_SAVE: "Save",
    COMMON_SAVE_AND_CLOSE: "Save and Close",
    COMMON_SEARCH: "Search",
    COMMON_TOTAL: "Total",
    COMMON_UNDO: "Undo",
    COMMON_VAH: "Varies Across Holdings",
    COMPONENT_BENCHMARK: "Benchmark",
    COMPONENT_FEES: "Fees",
    COMPONENT_HOLDINGS: "Time Period",
    COMPONENT_REBALANCING: "Rebalancing",
    COMPONENT_TAXES: "Taxes",
    COMPONENT_REINVESTMENTS: "Reinvestments",
    COMPONENT_CONTRIBUTIONS_WITHDRAWALS: "Contributions & Withdrawals",
    FEES_ADVISORY: "Advisory Fee",
    FEES_ADVISORY_FEE_NOT_INCLUDED: "Advisory fee not included",
    FEES_ANNUAL_ADVISORY_FEE: "Annual Advisory Fee %",
    FEES_ANNUAL_ASSET_BASED_ADVISORY_FEE: "Annual Asset-Based Advisory Fee %",
    FEES_APPLY_LETTER_OF_INTENT: "Apply Letter of Intent",
    FEES_APPLY_REDEMPTION_FEE_AND_DEFERRED_LOAD: "Apply Redemption Fee and Deferred Load",
    FEES_APPLY_TRANSACTION_FEES_FOR_REBALANCING: "Apply Transaction Fees for Rebalancing",
    FEES_BEGINNING_OF_PERIOD: "Beginning of Period",
    FEES_END_OF_PERIOD: "End of Period",
    FEES_FREQUENCY: "Frequency",
    FEES_FRONT_LOAD: "Front Load",
    FEES_FRONT_LOAD_CUSTOM: "Custom",
    FEES_FRONT_LOAD_CUSTOM_AMOUNT: "Custom $",
    FEES_FRONT_LOAD_CUSTOM_PERCENT: "Custom %",
    FEES_FRONT_LOAD_STANDARD: "Standard",
    FEES_FRONT_LOI: "Letter of Intent",
    FEES_HOLDINGS_FRONT_LOAD_AMOUNT: "Custom Front Load Amount",
    FEES_HOLDINGS_REDEMP_CHARGE: "Redemp/Deferred Charge",
    FEES_HOLDINGS_SCHEDULE: "Standard Fee Schedule",
    FEES_PORTFOLIO_SCHEDULE_LINK: "View Standard Fee Schedule",
    FEES_HOLDINGS_SCHEDULE_TABLE_LINK: "View",
    FEES_HOLDINGS_SCHEDULE_MODAL_TEXT: "Standard sales fees are listed here, when available. The values are taken from Morningstar's internal databases.",
    FEE_SCHEDULE_TYPE_P: "Contract Charges",
    FEE_SCHEDULE_TYPE_V: "Surrender Charges",
    FEE_SCHEDULE_TYPE_F: "Front-end Sales Charges",
    FEE_SCHEDULE_TYPE_D: "Back-end Sales Charges",
    FEE_SCHEDULE_TYPE_R: "Redemption Charges",
    FEE_SCHEDULE_TYPE_MT: "Annual Maintenance Fee",
    FEE_SCHEDULE_TYPE_L: "Low Sales Charges",
    FEE_SCHEDULE_TYPE_LOI: "Letter Of Intent Period",
    NO_FEE_SCHEDULE: " No Loads or Redemption Fees.",
    FEE_BREAKTYPE_USD: "$",
    FEE_BREAKTYPE_YEAR: "Year",
    FEE_BREAKTYPE_MONTH: "Month",
    FEE_BREAKTYPE_DAY: "Days",
    FEES_NO: "No",
    FEES_NOT_INCLUDED: "Fees not included",
    FEES_OUT_OF_POCKET: "Out of Pocket",
    FEES_PAY_ADVISORY_FEE_BY: "Pay Advisory Fee By",
    FEES_PAY_ADVISORY_FEES: "Pay Advisory Fees",
    FEES_SALE_OF_SHARES: "Sale of Shares",
    FEES_TRANSACTION: "Transaction Fee",
    FEES_TRANSACTION_FEE_NOT_INCLUDED: "Transaction fee not included",
    FEES_USE_CASE_FIRST: "Use Cash First",
    FEES_WHEN_WILL_FEES_BE_PAID: "When will fees be paid?",
    FEES_YES: "Yes",
    HOLDINGS_END_DATE: "End Date",
    HOLDINGS_FIRST_PRICE_DATE: "Earliest Price Available Date",
    HOLDINGS_ID: "ID",
    HOLDINGS_NAME: "Name",
    HOLDINGS_START_DATE: "Start Date",
    HOLDINGS_TIME_PERIOD: "Time Period",
    INVESTMENTS_TIME_PERIOD: "Investments Time Period",
    TIME_PERIOD_DESCRIPTION: "The availability of time period selections are based on both portfolios.",
    TIME_PERIOD_TOOLTIP_INVALID_DATE_FORMAT: "Date format is wrong.",
    TIME_PERIOD_TOOLTIP_END_BEFORE_START: "The end date cannot be before start date.",
    TIME_PERIOD_TOOLTIP_START_AFTER_END: "The start date can't be after end date.",
    TIME_PERIOD_TOOLTIP_START_BEFORE_EARLIEST: "The start date can't be before earliest available date.",
    TIME_PERIOD_TOOLTIP_END_NOT_AVAILABLE: "Data isn't ready for this end date.",
    TIME_PERIOD_TOOLTIP_MOST_RECENT_COMMON: "Click here to set the most recent common.",
    TIME_PERIOD_TOOLTIP_MOST_RECENT_AVAILABLE: "Click here to set the most recent available.",
    TIME_PERIOD_TOOLTIP_EARLIEST_AVAILABLE: "Click here to set earliest available.",
    TIME_PERIOD_OILPRICERISE: "Oil Price Rise",
    TIME_PERIOD_USFINANCIALCRISIS: "US Financial Crisis",
    TIME_PERIOD_OILPRICEDROP: "Oil Price Drop",
    TP_TOOLTIP_START_BEFORE_EARLIEST_COMMON: "The start date can't be before earliest common date.",
    TP_TOOLTIP_EARLIEST_COMMON: "Click here to set earliest common.",
    HOME_CARD_MENU_DELETE: "Delete",
    HOME_CARD_MENU_DUPLICATE: "Duplicate",
    HOME_DEFAULT_HYPO_NAME: "Hypothetical Illustration",
    HOME_PAGE_TITLE: "Open the hypothetical illustration or report you've saved",
    HOME_SAVE_DIALOG_TEXT: "You can revisit this illustration in your Files.",
    HOME_SAVE_DIALOG_TITLE: "Save changes to your hypothetical illustration?",
    PORTFOLIO_RENAME_DIALOG_TITLE: "What would you like to name this Portfolio?",
    PORTFOLIO_TRANSACTIONS_ADD: "Add Transaction",
    PORTFOLIO_TRANSACTIONS_COLUMN_END_DATE: "End Date (Month End)",
    PORTFOLIO_TRANSACTIONS_COLUMN_FREQUENCY: "Frequency",
    PORTFOLIO_TRANSACTIONS_COLUMN_START_DATE: "Start Date (Month End)",
    PORTFOLIO_TRANSACTIONS_COLUMN_TYPE: "Type",
    PORTFOLIO_TRANSACTIONS_TOOLTIP_ERROR_FORMAT: "Date format is wrong.",
    PORTFOLIO_TRANSACTIONS_TOOLTIP_ERROR_BEFORE_STARTDATE: "The transaction start date cannot be before portfolio start date.",
    PORTFOLIO_TRANSACTIONS_TOOLTIP_ERROR_AFTER_ENDDATE: "The transaction start date cannot be after portfolio end date.",
    PORTFOLIO_TRANSACTIONS_TOOLTIP_ERROR_USED_DATE: "You already set a one-time transaction for this date. Please select a different date.",
    PORTFOLIO_TRANSACTIONS_LIMIT_REACHED: "You can’t add transaction any more for the data limit reached.",
    PORTFOLIO_TRANSACTIONS_COLUMN_UNIT: "Unit",
    PORTFOLIO_TRANSACTIONS_COLUMN_VALUE: "Value",
    PORTFOLIO_TRANSACTIONS_CONTRIBUTION_ROW_NAME: "Contribution",
    PORTFOLIO_TRANSACTIONS_FREQUENCY_INITIAL: "Initial",
    PORTFOLIO_TRANSACTIONS_FREQUENCY_ONE_TIME: "One Time",
    PORTFOLIO_TRANSACTIONS_HOLDINGS_ROW_NAME: "Holdings",
    PORTFOLIO_TRANSACTIONS_REMOVED_TEXT: "Transaction Removed.",
    PORTFOLIO_TRANSACTIONS_TYPE_CONTRIBUTION: "Contribution",
    PORTFOLIO_TRANSACTIONS_TYPE_WITHDRAWAL: "Withdrawal",
    PORTFOLIO_TRANSACTION_TITLE: "Portfolio Transactions",
    PORTFOLIO_TRANSACTION_INVESTMENT_TITLE: "Investment Transactions",
    PORTFOLIO_TITLE: "Portfolio",
    PORTFOLIO_SECTION_TITLE: "This is the portfolio as of the most recent date",
    PREFERENCE_EDIT_PREFERENCE: "Edit Preference",
    PREFERENCE_SELECT_LANGUAGE: "Select Language",
    REBALANCING: "Rebalancing",
    REBALANCING_ASSET_BREAKDOWN: "Asset Breakdown",
    REBALANCING_CUSTOM: "Custom",
    REBALANCING_CUSTOM_WEIGHT: "Custom Weight %",
    REBALANCING_FREQUENCY: "Frequency",
    REBALANCING_ID: "Ticker",
    REBALANCING_INITIAL_ALLOCATION: "Initial Allocation",
    REBALANCING_INITIAL_WEIGHT: "Initial Weight %",
    REBALANCING_NAME: "Name",
    REBALANCING_REBALANCE_TO: "Rebalance to",
    REBALANCING_THRESHOLD: "Threshold %",
    ALERT_REBALANCE_TOTAL_TITLE: "Weight must total 100.00%",
    ALERT_REBALANCE_TOTAL_MSG: "Change individual weights to change the total",
    SUMMARY_HEADING: "Summary",
    SUMMARY_SCENARIO_ANALYSIS: "Scenario Analysis",
    SUMMARY_BUILD_REPORT: "Build Report",
    REPORT_BLOCKROCK_MANAGEMENT_FEES: "Management Fees(BlackRock)",
    REPORT_CA_FUND_SUMMARY: "Fund Summary Report(CAN)",
    REPORT_CA_PORTFOLIO_SERVICE_FEES: "Portfolio Services and Fees(CAN)",
    REPORT_CA_PORTFOLIO_SUMMARY: "Portfolio Summary Report(CAN)",
    REPORT_CASH_FLOW: "Cash Flow Report",
    REPORT_CA_STOCK_SUMMARY: "Stock Summary Report(CAN)",
    REPORT_CORRELATION_MATRIX: "Correlation Matrix",
    REPORT_COVER_PAGE: "Cover Page",
    REPORT_DISCLOSURE_MATERIALS: "Disclosure Materials",
    REPORT_DISTRIBUTION_WITHDRAWAL_COMPARISON: "Distribution and Withdrawal Comparison",
    REPORT_DISTRIBUTION_WITHDRAWAL_SUMMARY: "Distribution and Withdrawal Summary",
    REPORT_GENERATOR_COVER_PAGE_ADDRESS_LABEL: "Address",
    REPORT_GENERATOR_COVER_PAGE_CITY_LABEL: "City",
    REPORT_GENERATOR_COVER_PAGE_COUNTRY_LABEL: "Country",
    REPORT_GENERATOR_COVER_PAGE_EMAIL_LABEL: "Email",
    REPORT_GENERATOR_COVER_PAGE_FIRST_NAME_LABEL: "First Name",
    REPORT_GENERATOR_COVER_PAGE_LAST_NAME_LABEL: "Last Name",
    REPORT_GENERATOR_COVER_PAGE_OPTIONAL_FIELDS_TIP: "All fields below are optional.",
    REPORT_GENERATOR_COVER_PAGE_PHONE_LABEL: "Phone",
    REPORT_GENERATOR_COVER_PAGE_PREPARED_BY_LABEL: "Prepared by",
    REPORT_GENERATOR_COVER_PAGE_PREPARED_FOR_LABEL: "Prepared for",
    REPORT_GENERATOR_COVER_PAGE_PROVINCE_LABEL: "Province",
    REPORT_GENERATOR_COVER_PAGE_REPORT_TITLE_LABEL: "Report Title",
    REPORT_GENERATOR_COVER_PAGE_STATE_LABEL: "State",
    REPORT_GENERATOR_COVER_PAGE_STATE_PLACEHOLDER: "Select a State",
    REPORT_GENERATOR_COVER_PAGE_ZIP_LABEL: "Zip",
    REPORT_GENERATOR_GENERATE_BUTTON_TEXT: "Generate Report",
    REPORT_GENERATOR_HEADER: "Report Generator",
    REPORT_GENERATOR_TITLE: "Select the contents and provide the details to generate a PDF report for review.",
    REPORT_HOLDINGS_COMPARISON_FOR_HYPO: "Holdings Comparison",
    REPORT_INDIVIDUAL_HOLDINGS_FOR_HYPO: "Individual Holdings",
    REPORT_INVESTMENT_DETAIL: "Investment Details",
    REPORT_INVESTMENT_GROWTH: "Investment Growth",
    REPORT_MARKETING_PAGE: "Marketing Page",
    REPORT_MORGST_INVESTMENT_SUMMARY: "Investment Summary(MORGST)",
    REPORT_PORTFOLIO_COMPARISON: "Portfolio Comparison",
    REPORT_PORTFOLIO_COMPARISON_FOR_HYPO: "Portfolio Comparison",
    REPORT_PORTFOLIO_COMPARISON_FOR_HYPO_DES: "Illustrates how a portfolio would have performed in relation to the other competing portfolio.",
    REPORT_PORTFOLIO_FOR_HYPO: "Single Portfolio",
    REPORT_PORTFOLIO_FOR_HYPO_DES: "Illustrates how a portfolio of investments would have performed.",
    REPORT_PORTFOLIO_ROLLING_RETURNS: "Portfolio Rolling Returns",
    REPORT_Portfolio_XRay: "Portfolio X-Ray",
    REPORT_PRICE_DISTRIBUTION: "Price and Distribution Report",
    REPORT_RISK_REWARD: "Risk/Reward Scatterplot",
    REPORT_ROLLING_RETURNS: "Rolling Returns",
    REPORT_SNAPSHOT: "Portfolio Snapshot",
    REPORT_STOCK_INTERSECTION: "Stock Intersection",
    REPORT_TOTAL_ANNUAL_RETURN: "Total Annual Return",
    REPORT_UNDERLYING_HOLDINGS: "Underlying Holdings Report",
    REVIEW_AND_EDIT_ASSUMPTIONS: "Review and edit the assumptions for Portfolio",
    REVIEW_AND_EDIT_ASSUMPTIONS_INVESTMENTS: "Review and edit the assumptions for all chosen Investments",
    SETTINGS_ALLOCATEBY_AMOUNT: "Amount",
    SETTINGS_ALLOCATEBY_PERCENTAGE: "Percentage",
    SETTINGS_ALLOCATEBY_SHARES: "Shares",
    SETTINGS_BENCHMARK_METHOD: "Method",
    SYNCED_PREFERENCES: "Synced with Preferences",
    SYNCED_PORTFOLIO: "Synced with Portfolio 1",
    SYNC_PORTFOLIO: "Sync with Portfolio 1",
    SYNC_PORTFOLIO_TOTAL_AMOUNT: "Sync Total Amount with Portfolio",
    TAXES_CAPITAL_GAIN: "Capital Gain %",
    TAXES_FEDERAL_INCOME: "Federal Income %",
    TAXES_FILING_STATUS: "Filing Status",
    TAXES_INFORMATION: "Client Tax Information",
    TAXES_OUT_OF_POCKET: "Out of Pocket",
    TAXES_PAY_OPTION: "Pay Option",
    TAXES_FEDERAL_INCOME_TAX: "Federal Income Tax",
    TAXES_STATE_TAX: "State Tax",
    TAXES_CAPITAL_GAIN_TAX: "Capital Gain Tax",
    TAXES_RATE: "Tax Rate",
    TAXES_SALE_OF_SHARES: "Sale of Shares",
    TAXES_STATE: "State %",
    TAXES_TAXABLE_INCOME: "Taxable Income",
    TAXES_AVAILABLE_ALERT_TITLE: `Taxes Not Available`,
    TAXES_AVAILABLE_ALERT_ALL: `We don't support the complex tax calculations for Variable Annuity subaccounts and 529 portfolios. 
    Please remove them in the previous step if you want to calculate taxes.`,
    TAXES_AVAILABLE_ALERT_VA: `We don't support the complex tax calculations for Variable Annuity subaccounts. 
    Please remove them in the previous step if you want to calculate taxes.`,
    TAXES_AVAILABLE_ALERT_529: `We don't support the complex tax calculations for 529 portfolios. Please remove them in the previous step if you want to calculate taxes.`,
    TIME_PERIOD_CUSTOM: "Custom",
    TIME_PERIOD_EARLIEST_AVAILABLE: "Earliest Available",
    TIME_PERIOD_EARLIEST_COMMON: "Earliest Common",
    TIME_PERIOD_SINCE_INCEPTION: "Since Inception",
    TIME_PERIOD_TRAILING_1_YEAR: "Trailing 1 Year",
    TIME_PERIOD_TRAILING_3_YEAR: "Trailing 3 Years",
    TIME_PERIOD_TRAILING_5_YEAR: "Trailing 5 Years",
    TIME_PERIOD_TRAILING_10_YEAR: "Trailing 10 Years",
    TIME_PERIOD_TRAILING_15_YEAR: "Trailing 15 Years",
    TRAILING_RETURN_XDOMAIN_1_MONTH: "1 Month",
    TRAILING_RETURN_XDOMAIN_3_MONTH: "3 Month",
    TRAILING_RETURN_XDOMAIN_6_MONTH: "6 Month",
    TRAILING_RETURN_XDOMAIN_1_YEAR: "1 Year",
    TRAILING_RETURN_XDOMAIN_2_YEAR: "2 Year",
    TRAILING_RETURN_XDOMAIN_3_YEAR: "3 Year",
    TRAILING_RETURN_XDOMAIN_5_YEAR: "5 Year",
    TRAILING_RETURN_XDOMAIN_10_YEAR: "10 Year",
    TRANSACTION: "Transaction",
    TRANSACTIONS: "Transactions",
    TRANSACTIONS_CONTRIBUTION: "Contribution",
    LIQUIDATE_ON_END_DATE: "Liquidate on End Date",
    LIQUIDATE_PORTFOLIO_ON_END_DATE: "Liquidate portfolio on end date",
    LIQUIDATE_INVESTMENT_ON_END_DATE: "Liquidate investment on end date",
    LIQUIDATION_ON_END_DATE: "Liquidation on End Date",
    TRANSACTIONS_NO: "No",
    TRANSACTIONS_REINVESTCAPITALGAINS: "Reinvest Capital Gains",
    TRANSACTIONS_REINVESTDIVIDENDS: "Reinvest Dividends/Income",
    TRANSACTIONS_WITHDRAWAL: "Withdrawal",
    TRANSACTIONS_YES: "Yes",
    TRANSACTIONS_UNIT: "Unit",
    TRANSACTIONS_START_DATE: "Start Date (Month End)",
    TRANSACTIONS_END_DATE: "End Date (Month End)",
    TYPE_TITLE: "Select the type of hypothetical illustration you would like to create",
    CT_GENERATE_RPT: "Generate Report",
    CT_MKT_PAGE: "Marketing Page",
    CT_PORT_XRAY: "Portfolio X-Ray",
    PORTFOLIO_MORE_THAN_ONE_YEAR_OLDER_WARNING:
        "The asset allocation data of {{portfolioWarning}} is not available because the custom time period ends older than a year.",
    PORTFOLIO_REPORT_MORE_THAN_ONE_YEAR_OLDER_WARNING:
        "The asset allocation data and portfolio reports of {{portfolioReportWarning}} are not available because the custom time period ends older than a year."
};
